import { useCallback, useEffect, useState } from 'react';
import {
  TableFiltersSection,
  TableFilter,
  ChakraFlex,
  ChakraBox,
} from '@equip.health/ui';
import UserFilterPopover from './UserFiltersPopover';

interface UserFiltersProps {
  id: string;
  selectedFilters: TableFilter[];
  onFiltersChange: (val: TableFilter[]) => void;
}

const UserFilters = ({
  id,
  selectedFilters,
  onFiltersChange,
}: UserFiltersProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    setRefreshKey((prev) => prev + 1);
  }, [selectedFilters]);

  const handleFiltersChange = useCallback(
    (filters: TableFilter[]) => {
      onFiltersChange(filters);
      setRefreshKey((prev) => prev + 1);
      setIsOpen(false);
    },
    [onFiltersChange],
  );

  return (
    <ChakraFlex
      align="flex-end"
      direction="column"
      paddingRight="30px"
      width="100%"
    >
      <TableFiltersSection
        filters={selectedFilters}
        key={refreshKey}
        onAddFilter={() => setIsOpen(true)}
        onFiltersChange={handleFiltersChange}
        tableName="user-list"
      />

      <ChakraBox position="relative" width="360px">
        <UserFilterPopover
          id={id}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          onSaveFilters={handleFiltersChange}
          selectedFilters={selectedFilters}
        />
      </ChakraBox>
    </ChakraFlex>
  );
};

export default UserFilters;
